import styled from 'styled-components';
import tw, { classnames, TBackgroundColor, position, borderRadius, height, margin, padding, textColor, boxShadow, backgroundColor } from 'tailwindcss-classnames';

const maniClass = classnames(position('relative'), borderRadius('rounded-sm'), height('h-20'), margin('my-3'), padding('px-3', 'md:px-5', 'xl:px-4', 'py-3', 'md:py-4', 'xl:py-3'), textColor('text-white'), boxShadow('shadow-lg'));
export const StyledNavLink = styled.a.attrs({ className: maniClass })`
    font-weight: 300;
`;
export const PrimaryClass = classnames(maniClass, backgroundColor('bg-gpas-700', 'hover:bg-gpas-900'));
export const SecondaryClass = classnames(maniClass, textColor('text-purple-500', 'hover:text-purple-700'), backgroundColor('bg-purple-100'));
export const WhiteClass = 'text-white hover:text-white py-2 px-4';
